import React, {useEffect, useState} from 'react';
import './style.scss';
import {Button, Col, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import ProPortalHeader from "../../../componets/ProPortalHeader";
import ProfileRow from "../../../componets/ProfileRow";
import Navigator from "../../../componets/Navigator";
import {get_api, post_api, post_api_upload} from "../../../serverTemp";
import Camera from './imgs/camera.svg';
import SparkMD5 from 'spark-md5';

const MainContent = () => {
    const [user, setUser] = useState({})
    const [newData, setNewData] = useState({
        id: localStorage.getItem('user_id'),
        avatar: '',
        email: '',
        nickname: '',
    });
    const [selectedImage, setSelectedImage] = useState(null); // 新增状态用于存储图片

    useEffect(() => {
        get_api('/user/detail').then(res => {
            console.log(res)
            setUser(res);
            setNewData({
                ...newData,
                avatar: res.avatar,
                email: res.email,
                nickname: res.nickname
            });
        });
    }, []);
    const calculateFileMD5 = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            // 读取文件完成后触发的事件
            reader.onload = function (e) {
                const data = e.target.result;
                const md5 = SparkMD5.ArrayBuffer.hash(data); // 计算MD5
                resolve(md5);
            };

            reader.onerror = function (error) {
                reject(error);
            };

            // 以ArrayBuffer的形式读取文件内容，以便MD5库可以处理
            reader.readAsArrayBuffer(file);
        });
    };

    //新增函数用于处理文件选择
    const handleFileChange = async (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const fileMD5 = await calculateFileMD5(file);
            post_api_upload(file.name, fileMD5, file)
                .then((url)=>{
                    console.log("Response URL:", url);
                    setSelectedImage(URL.createObjectURL(file));
                    setNewData({...newData, avatar: url});
                })
        }
    };

    // 新增函数用于触发隐藏的文件输入
    const triggerFileInput = () => {
        document.getElementById('fileInput').click();
    };

    // 定义转换函数
    const getSubscriptionType = (subscription) => {
        const types = ["Standard", "Advanced", "Premium"];
        return types[subscription] || "Unknown";
    };
    // const handleInputChange = (e) => {
    //     setNewData({...newData, [e.target.name]: e.target.value});
    // };
    // const handleInputChange = (e) => {
    //     if (e.target.name === 'email') {
    //         // 如果用户在修改邮箱地址输入框中输入内容，不进行任何操作，因为邮箱地址不可编辑
    //         return;
    //     }
    //     setNewData({...newData, [e.target.name]: e.target.value});
    // };
    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setNewData(prevData => ({
    //         ...prevData,
    //         [name]: value
    //     }));
    // };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewData(prevData => ({
            ...prevData,
            [name]: value
        }));
        console.log('Updated newData:', newData);
    };


    // const saveChanges = async () => {
    //     console.log('Saving new data:', newData);
    //     post_api('/user/update', newData).then(res => {
    //     })
    // };
    const saveChanges = async () => {
        console.log('Saving new data:', newData);
        post_api('/user/update', newData)
            .then(res => {
                console.log('Update response:', res);
                // 重新获取用户数据
                get_api('/user/detail').then(res => {
                    console.log('New user data:', res);
                    setUser(res);
                });
            })
            .catch(error => {
                console.error('Error while updating:', error);
            });
    };


    return (
        <Row gutter={16}>
            <Col span={12}>
                <p className='PortalAccountDetails-title'>Change your details</p>
                <div>
                    <div className="MD-form-group">
                        <label className='MD-form-group-label'>Account name</label><br/>
                        <input className='MD-form-group-input'
                               type="text"
                               name={'nickname'}
                               onChange={handleInputChange}
                        />
                    </div>
                    <div className="MD-form-group">
                        <label className='MD-form-group-label'>Email address</label><br/>
                        {/*<input className='MD-form-group-input'*/}
                        {/*       type="email"*/}
                        {/*       name={'email'}*/}
                        {/*       onChange={handleInputChange}*/}
                        {/*/>*/}
                        <input className='MD-form-group-input' placeholder={user.email}
                               disabled></input>
                    </div>
                    <div className="MD-form-group">
                        <label className='MD-form-group-label'>Subscription type</label><br/>
                        <input className='MD-form-group-select' placeholder={getSubscriptionType(user.subscription)}
                               disabled></input>
                        {/*<p className='MD-form-group-text'>If you wish to change your subscription level, please contact us.</p>*/}
                    </div>
                </div>
                <p className='PortalAccountDetails-content'>
                    To learn more about our subscription plans or upgrade your current subscription,<br/>
                    please visit our <a href="./MyAccount" className="subscriptionLink">Subscription page</a> for
                    detailed information.
                </p>
            </Col>
            <Col span={12}>
                <div className="profile-picture">
                    {/*<img src={selectedImage || Camera} alt="Profile" className="Camera-icon"/>*/}
                    <img src={selectedImage || Camera} alt="Profile"
                         className={`Camera-icon ${!selectedImage ? "default-icon" : ""}`}/>
                </div>
                <Button className='profile-picture-button' onClick={triggerFileInput}>
                    Update profile picture
                </Button>
                {/* 隐藏的文件输入 */}
                <input type="file" id="fileInput" style={{display: 'none'}} onChange={handleFileChange}/>
            </Col>
            <Button className="MD-Save-button" onClick={saveChanges}>Save changes</Button>
        </Row>
    )
};

const ChangeAccountDetails = () => {
    return (
        <Layout>
            <Content>
                <ProPortalHeader/>
                <ProfileRow/>
                <Row justify={"center"}>
                    <Layout>
                        <Navigator/>
                        <Layout>
                            <div className='ProAccountDetails'>
                                <p className='ProAccountDetails-title'>Hello Vieunite Ltd</p>
                                <MainContent/>
                            </div>
                        </Layout>
                    </Layout>
                </Row>
            </Content>
        </Layout>
    );
}

export default ChangeAccountDetails;